/**
 * FontsFooter
 *
 * Description of component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import { get } from 'lodash';
import classNames from 'classnames';

// Components
import Responsive from 'components/Responsive';
import Link from 'components/Link';
import Icon from 'components/Icon';
import SpecialOffer from 'components/SpecialOffer';

import { generateLicensePhrase, licenseIsPopulated } from 'utils';

// Styles
import styles from './styles.css';

export default class FontsFooter extends React.Component {
	constructor(props) {
		super(props);
		autobind(this);
		this.ref = React.createRef();
	}

	state = {
		expanded: false
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.closeSpecialOffers);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.closeSpecialOffers);
	}

	toggleSpecialOffers() {
		const { expanded } = this.state;
		this.setState({ expanded: !expanded });
	}

	closeSpecialOffers(event) {
		const { expanded } = this.state;
		if (expanded && this.ref.current && !this.ref.current.contains(event.target)) {
			this.setState({ expanded: false });
		}
	}

	renderSpecialOffer() {
		const {
			changeRoute, licenses, link, productLine, specialOffers, user
		} = this.props;

		const message = generateLicensePhrase({
			computers: licenses.computer.value,
			web: licenses.cloud.inCart || get(user, 'subscriptions.cloud', false),
			apps: licenses.app.inCart || get(user, 'subscriptions.app', false)
		});

		const specialOfferText = get(specialOffers, 'special_offers.special_offers.0.text');
		const specialOfferLinks = get(specialOffers, 'special_offers.special_offers.0.links', []);

		return (
			<SpecialOffer
				changeRoute={ changeRoute }
				className={ styles.specialOffer }
				id={ get(specialOffers, 'special_offers.special_offers.0.id') }
				license={ licenseIsPopulated(licenses) && { text: message } }
				link={
					specialOfferLinks.length === 0 && link ? {
						to: link.to,
						eventLabel: 'footer',
						eventValue: productLine ? Number(productLine.id) : 0
					} : null
				}
				message={ specialOfferText }
				name={ get(specialOffers, 'special_offers.special_offers.0.name') }
				parent="footer"
				position="fontsFooter"
			/>
		);
	}

	render() {
		const {
			containerClassName,
			isMobileFixedToScreen,
			isMobileVisible,
			link,
			specialOffers
		} = this.props;

		const { expanded } = this.state;

		const specialOfferText = get(specialOffers, 'special_offers.special_offers.0.text');

		return (
			<div
				className={ classNames(containerClassName, styles.container) }
				ref={ this.ref }
			>
				{ isMobileFixedToScreen &&
					<div className={ styles.footerPlaceholder } />
				}
				<footer
					className={ classNames(
						styles.footer,
						link && styles['footer--withLink'],
						expanded && styles['footer--expanded'],
						(specialOfferText || isMobileVisible) && styles['footer--withSpecialOffer'],
						isMobileFixedToScreen && styles['footer--fixed']
					) }
				>
					<Responsive className={ styles.content } direction="row">
						{ specialOfferText &&
							<div className={ styles.specialOfferButton } onClick={ this.toggleSpecialOffers } role="button" tabIndex={ 0 }>
								<Icon className={ classNames(styles.icon, styles.iconSpecialOffer) } iconName="starburst" />
								Special Offers...
							</div>
						}
						{ expanded && specialOfferText &&
								this.renderSpecialOffer()
						}
						{ link &&
							<Link
								className={ classNames(
									styles.link,
									link.isColorSecondary && styles['link--secondary']
								) }
								to={ link.to }
							>
								{ !link.arrowAfter && <Icon className={ classNames(styles.icon, styles['icon--before']) } iconName="forward" /> }
								{ link.text }
								{ link.arrowAfter && <Icon className={ classNames(styles.icon, styles['icon--after']) } iconName="forward" /> }
							</Link>
						}
					</Responsive>
				</footer>
			</div>
		);
	}
}

FontsFooter.propTypes = {
	changeRoute: PropTypes.func.isRequired,
	containerClassName: PropTypes.string,
	isMobileFixedToScreen: PropTypes.bool,
	isMobileVisible: PropTypes.bool,
	licenses: PropTypes.object,
	link: PropTypes.shape({
		arrowAfter: PropTypes.bool,
		to: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		isColorSecondary: PropTypes.bool
	}),
	productLine: PropTypes.object,
	specialOffers: PropTypes.object,
	user: PropTypes.object
};

FontsFooter.defaultProps = {
	containerClassName: null,
	isMobileFixedToScreen: false,
	isMobileVisible: false,
	licenses: null,
	link: null,
	productLine: null,
	specialOffers: null,
	user: null
};
